import ExaminationSolutionDetails from './ExaminationSolutionDetails';

export default ExaminationSolutionDetails;
